export interface IconProps {
  icon: IconList;
}

export enum IconList {
  NONE = "none",
  PHONE = "phone",
  ARROW_LEFT = "arrow_left",
  ARROW = "arrow",
  ARROW_RIGHT = "arrow_right",
  ARROW_DOWN = "arrow_down",
  ARROW_UP = "arrow_up",
  TWENTY_FOUR = "twenty_four",
  LINK = "link",
  PRICE = "price",
  LIST = "list",
  DOWNLOAD = "download",
  CREMATION = "cremation",
  BURIAL = "burial",
  URN_AT_HOME = "urnAtHome",
  TREE_FUNERAL = "treeFuneral",
  SEA_FUNERAL = "seaFuneral",
  GEMSTONE = "gemstone",
  URN_AT_HOME_2 = "home_urn",
  TREE_FUNERAL_2 = "tree_funeral",
  SEA_FUNERAL_2 = "sea_funeral",
  GEMSTONE_2 = "gemstone_funeral",
}

export enum DrawingIconList {
  NONE = "none",
  CANDLE = "candle",
  EURO = "euro",
  CHECK = "check",
  ONE = "one",
  TWO = "two",
  THREE = "three",
  FOUR = "four",
  FIVE = "five",
  SIX = "six",
  SEVEN = "seven",
  EIGHT = "eight",
  NINE = "nine",
  TEN = "ten",
}

export const NumberedDrawList: DrawingIconList[] = [
  DrawingIconList.ONE,
  DrawingIconList.TWO,
  DrawingIconList.THREE,
  DrawingIconList.FOUR,
  DrawingIconList.FIVE,
  DrawingIconList.SIX,
  DrawingIconList.SEVEN,
  DrawingIconList.EIGHT,
  DrawingIconList.NINE,
  DrawingIconList.TEN,
];
